import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

const initialState: any = null;

export const visitNoteSlice = createSlice({
  name: 'visitNotes',
  initialState,
  reducers: {
    visitNotesAction: (state, action: PayloadAction<any>) => action.payload,
  },
});

// Action creators are generated for each case reducer function
export const { visitNotesAction } = visitNoteSlice.actions;

export default visitNoteSlice.reducer;
